import { nb } from "../../../../date-fns/locale/nb.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    nb
  }
};